// Configure a client instance
import KeenTracking from 'keen-tracking';

// This is your actual Project ID and Write Key
const client = new KeenTracking({
    projectId: '5b2b79bcc9e77c00012e014a',
    writeKey: 'BCE38D05B60C0D405F74FC6F01D5BE1DA6B1B2C33FDA16878AF5DB33F720AA3E0863B87C825A366C3BB83F70155437AFC7D21922BAD26D824EE816B910514BF638242F05FDA5CEB87BAB99B92D19697744E61AF097917753A2897AB3E243A5B9',
    host: 'embed.easyscale.be/analytics-api',
    protocol: 'https'
});


export default (name, event) => {
    if(process.env.NODE_ENV === "production") {
        console.log('Logging to Keen.IO: ', name, event)
        return client.recordEvent('dashboard-' + name, event)
    } else {
        console.log('Fake Logging to Keen.IO: ', name, event)
    }
}